import React, { useRef } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./SponsorsSection.css";
import { useTranslation } from 'react-i18next';

import company1 from "../../assets/sponsors/company1.png";
import company2 from "../../assets/sponsors/company2.png";
import company3 from "../../assets/sponsors/company3.png";
import company4 from "../../assets/sponsors/company4.png";
import company5 from "../../assets/sponsors/company5.png";
import company6 from "../../assets/sponsors/company6.png";

// Bootstrap Icons
import "bootstrap-icons/font/bootstrap-icons.css";

const partnerLogos = [
  company1, company2, company3, company4, company5, company6
];

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1400 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 1400, min: 1024 },
    items: 4
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 3
  },
  mobile: {
    breakpoint: { max: 768, min: 0 },
    items: 2
  }
};

const CustomDot = ({ onClick, active }) => (
  <span
    className={`custom-dot ${active ? "active" : ""}`}
    onClick={onClick}
  ></span>
);

export default function PartnersSection() {
  const { t, i18n } = useTranslation();
  const carouselRef = useRef();
  
  const isRTL = i18n.dir() === 'rtl';

  return (
    <section className="partners-section">
      <div className="section-decoration decoration-1"></div>
      <div className="section-decoration decoration-2"></div>

      <div className="section-container">
        <div className="Partners-header">
          <h2 className="vision-title">{t('sponsors.title')}</h2>
          <div className="vision-divider">
            <span className="divider-line"></span>
            <span className="divider-diamond">◆</span>
            <span className="divider-line"></span>
          </div>
          <p className="vision-subtitle">
            {t('sponsors.subtitle')}
          </p>
        </div>

        <Carousel
          ref={carouselRef} 
          responsive={responsive}
          infinite
          autoPlay
          autoPlaySpeed={3000}
          arrows={false}
          customDot={<CustomDot />}
          showDots
          pauseOnHover
          containerClass="carousel-container"
          dotListClass="custom-dot-list"
          itemClass="partner-slide-wrapper"
        >
          {partnerLogos.map((logo, index) => (
            <div className="partner-slide" key={index}>
              <img src={logo} alt={t('sponsors.logoAlt', { number: index + 1 })} />
            </div>
          ))}
        </Carousel>

       <div className="carousel-controls">
  <button 
    className="custom-arrow-wrapper" 
    onClick={() => carouselRef.current?.previous()}
    aria-label={t('sponsors.prevButton')}
  >
    <i className="bi bi-arrow-left-circle-fill"></i> {/* ← ثابت للسابق */}
  </button>

  <div className="custom-dot-list-wrapper"></div>

  <button 
    className="custom-arrow-wrapper" 
    onClick={() => carouselRef.current?.next()}
    aria-label={t('sponsors.nextButton')}
  >
    <i className="bi bi-arrow-right-circle-fill"></i> {/* → ثابت للتالي */}
  </button>
</div>

      </div>
    </section>
  );
}